import { render, staticRenderFns } from "./creat-stick.vue?vue&type=template&id=1d675535&scoped=true"
import script from "./creat-stick.vue?vue&type=script&lang=js"
export * from "./creat-stick.vue?vue&type=script&lang=js"
import style0 from "./creat-stick.vue?vue&type=style&index=0&id=1d675535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d675535",
  null
  
)

export default component.exports